import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { ConvenienceTestsConfirmParams, ConvenienceTestsConfirmResponse } from '@repo/user-types'

const initialState: GenericOperationState<ConvenienceTestsConfirmResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: convenienceTestsConfirmActions, reducer: convenienceTestsConfirmReducer } =
  createOperationSlice<
    ConvenienceTestsConfirmResponse | null,
    SliceCaseReducers<GenericOperationState<ConvenienceTestsConfirmResponse | null>>,
    ConvenienceTestsConfirmParams
  >({
    name: '@users/convenienceTestsConfirm',
    initialState,
    reducers: {},
  })
